import { useEffect, useState } from 'react'

/** true, solange das Fenster mindestens `minWidth` Pixel breit ist. */
export function useWideViewport(minWidth: number): boolean {
  const query = `(min-width: ${minWidth}px)`
  const [wide, setWide] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  )
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setWide(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])
  return wide
}
